import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { LaboratoryInfoRequest } from '@/module/Laboratory';

import { Form, TextInputControl } from '@/core/components';

interface LabInfoChangeFormProps {
  onClose: () => void;
  isSubmitting: boolean;

  onChange: (request: LaboratoryInfoRequest) => void;

  defaultValues: LaboratoryInfoRequest;
}

export const labInfoChangeSchema = z.object({
  domain: z.string().trim().min(3),
  researchTeam: z.string().toLowerCase().trim().min(3),
});

type LabInfoChangeSchema = z.infer<typeof labInfoChangeSchema>;

export function LabInfoChangeForm(props: LabInfoChangeFormProps) {
  const { onClose, isSubmitting, onChange, defaultValues } = props;
  const { t } = useTranslation();
  const form = useForm<LabInfoChangeSchema>({
    defaultValues,
    resolver: zodResolver(labInfoChangeSchema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      size="xl"
      title={t('labs.changeInfo')}
    >
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(onChange)}
          onCancel={onClose}
          title=""
          isSubmitting={isSubmitting}
        >
          <TextInputControl<LabInfoChangeSchema>
            label={t('labs.domain')}
            name="domain"
            description={t('labs.domain')}
            isSubmitting={isSubmitting}
          />
          <TextInputControl<LabInfoChangeSchema>
            label={t('labs.researchTeam')}
            name="researchTeam"
            description={t('labs.researchTeam')}
            isSubmitting={isSubmitting}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
}
